import { app } from '../../../../../app';
import { Controller } from './customize-user-authentication.controller';

app.component('customizeUserAuthentication', {
    bindings: {
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./customize-user-authentication.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/customize-user-authentication/customize-user-authentication.component.js